import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { DropdownPosition } from '@ng-select/ng-select';

@Component({
  selector: 'div[app-filter-dropdown]',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterDropdownComponent implements OnInit {
  @Input() horizontalExpandedMenu: boolean = false;
  @Input() showSelectedLabels: boolean = false;
  @Input() showSelectionCount: boolean = false;
  @Input() selectedItems: any[] = [];
  @Input() items: Array<any> = [];
  @Input() placeholder: string = 'Filter';
  @Input() bindLabel: string = '';
  @Input() bindValue: string = '';
  @Input() appendTo: string = '.main-content';
  @Input() searchable: boolean = false;
  @Input() clearable: boolean = true;
  @Input() dropdownPosition: DropdownPosition = 'bottom';

  @Output() selectedItemsChange: EventEmitter<any[]> = new EventEmitter();
  @Output() clear: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  updateFilter() {
    this.selectedItemsChange.emit(this.selectedItems);
    this.close.emit(true);
  }

  clearFilter(){
    this.clear.emit(true);
  }
}
